const changeLanguage = (lng: string) => {
  const isProduction = process.env.REACT_APP_IS_PROD === "TRUE";
  let domain;

  if (isProduction) {
    domain =
      lng === "es"
        ? process.env.REACT_APP_DOMAIN_ES
        : process.env.REACT_APP_DOMAIN_EN;
  } else {
    domain =
      lng === "es"
        ? process.env.REACT_APP_DOMAIN_ES_TEST
        : process.env.REACT_APP_DOMAIN_EN_TEST;
  }

  if (domain) {
    // Capturar ruta actual
    const { pathname, search, hash } = window.location;
    const currentRoute = `${pathname}${search}${hash}`;

    // Redirigir manteniendo la ruta
    window.location.href = domain + currentRoute;
  }
};

export default changeLanguage;
